import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_TRANSACOES_PROGRAMADAS = "getTransacoesProgramadas";
export const GET_TRANSACAO_PROGRAMADA = "getTransacaoProgramada";
export const DELETE_TRANSACAO_PROGRAMADA = "deleteTransacaoProgramada";
export const UPDATE_TRANSACAO_PROGRAMADA = "updateTransacaoProgramada";

const state = {};

const getters = {};

const actions = {
    [GET_TRANSACOES_PROGRAMADAS](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesProgramadas/" + dados.pagina + "/" + dados.quantidade, {
                    buscar: dados.buscar,
                    sortBy: dados.sortBy,
                    sortDesc: dados.sortDesc
                }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_TRANSACAO_PROGRAMADA](context, idTransacaoProgramada) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("transacaoProgramada/" + idTransacaoProgramada).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [DELETE_TRANSACAO_PROGRAMADA](context, idTransacaoProgramada) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("transacaoProgramada/" + idTransacaoProgramada + "/E").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_TRANSACAO_PROGRAMADA](context, transacaoProgramada) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacaoProgramada", transacaoProgramada).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};